// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:08.608Z
// Property: Patriot Pointe Townhomes (ID: 6767906449167019)
// Collections: 18 amenities, 3 floorplans (live), 17 photos, 38 POIs, 4 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167019",
  "property_external_id": "900f7k6",
  "property_zillow_url": "https://www.zillow.com/apartments/north-ogden-ut/patriot-pointe/Cnfz7y/",
  "property_apartments_url": "https://www.apartments.com/patriot-pointe-north-ogden-ut/900f7k6/",
  "property_google_business_url": "https://www.google.com/maps/place/Patriot+Pointe/@41.3004596,-111.976427,17z/data=!3m1!4b1!4m5!3m4!1s0x87530dbc24ace4a9:0xf87bf1292140b6b5!8m2!3d41.3004556!4d-111.974233?coh=164777&entry=tt&shorturl=1",
  "property_linkedin_url": null,
  "property_hubspot_id": "55404718606",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "741PPT",
  "property_status": null,
  "property_slug": "patriot-pointe-townhomes",
  "property_name": "Patriot Pointe Townhomes",
  "property_website_url": "https://www.liveatpatriotpointe.com/",
  "property_domain": "https://www.liveatpatriotpointe.com/",
  "property_address": "115 E 2300 N",
  "property_full_address": "115 E 2300 N, North Ogden, UT 84414",
  "property_address_1": "115 E 2300 N",
  "property_address_2": null,
  "property_address_city": "North Ogden",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84414",
  "property_address_country": "US",
  "property_address_county": "Weber County",
  "property_neighborhood_address": "North Ogden",
  "property_address_latitude": "41.2997304",
  "property_address_longitude": "-111.9769437",
  "property_email": null,
  "property_phone": "(801) 317-1162",
  "property_call_tracking_phone": null,
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Patriot Pointe Townhomes in North Ogden, UT, your ideal home awaits. Choose from spacious two- and three-bedroom floor plans featuring modern finishes like granite countertops and stainless steel appliances. Enjoy the luxury of walk-in closets and direct access garages. Your perfect blend of comfort and style is here!",
  "property_long_description": "Patriot Pointe Townhomes are peacefully nestled in a budding North Ogden neighborhood. Inside each of our 1, 2, and 3 bedroom townhomes, you will enjoy brand-new appliances, in-unit washer and dryer machines, high ceilings, granite countertops, and designer finishes. Each spacious and well-appointed unit is pet-friendly and comes with an attached garage, to name just a few of our mindfully-modern amenities.\n\nMaximize the advantages of a suburban location with the adventure of outdoor living. Enjoy a night out on historic 25th Street or escape the city to the many hiking/biking trails that Ben Lomond Mountain has to offer. Cool off in the summer at North Shore Aquatic Center and Pineview Reservoir, or hit the slopes of Powder Mountain and Nordic Valley Ski Resorts. The adventure is just beginning at Patriot Pointe Townhomes!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-0268-7632-967d-4c795de8114e.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior courtyard of modern townhomes with lush green grass and a paved walkway.",
    "public_id": "019d02d7-0268-7632-967d-4c795de8114e",
    "storage_key": "property/6767906449167019/019d02d7-0268-7632-967d-4c795de8114e.webp",
    "width": 1400,
    "height": 1049
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "129",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.12403100775194",
  "property_admin_fee": "299",
  "property_application_fee": "50",
  "property_fees_deposit_info": "$250",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "100",
  "property_monthly_pet_rent": "45",
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "null",
  "property_pet_policy_description": "We welcome pets and are a pet‑enthusiastic community. (Note: specific details such as types of pets allowed, maximum weights, number of pets, and monthly pet rent are not provided on the website.)",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://patriotpointe.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcpatriotpointetownhomes",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d8-14b9-728b-b638-8b3632999296.webp",
  "property_primary_logo_media": {
    "alt_text": "Patriot Pointe Townhomes logo",
    "public_id": "019d02d8-14b9-728b-b638-8b3632999296",
    "storage_key": "property/6767906449167019/019d02d8-14b9-728b-b638-8b3632999296.webp",
    "width": 200,
    "height": 156
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d8-1e17-761a-8a27-123cd4c5ca5b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Black square image",
    "public_id": "019d02d8-1e17-761a-8a27-123cd4c5ca5b",
    "storage_key": "property/6767906449167019/019d02d8-1e17-761a-8a27-123cd4c5ca5b.webp",
    "width": 1,
    "height": 1
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d8-2446-7618-bdda-e99301aab0d5.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Swimming pool area at apartment complex",
    "public_id": "019d02d8-2446-7618-bdda-e99301aab0d5",
    "storage_key": "property/6767906449167019/019d02d8-2446-7618-bdda-e99301aab0d5.webp",
    "width": 1,
    "height": 1
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "860 - 1435",
  "property_sqft_min": "860",
  "property_sqft_max": "1435",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "1939",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/61569035810987/",
  "property_instagram_url": "https://www.instagram.com/northpointetownhomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJqeSsJLwNU4cRtbZAISnxe_g",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/patriot-pointe-by-tec-management-north-ogden",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Patriot Pointe Townhomes",
  "property_home_romance_title": "Embrace a Life You Love in Our Charming Apartments",
  "property_home_amenities_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, each two and three-bedroom apartment boasts spacious floor plans with modern finishes, including granite countertops and stainless steel appliances. Enjoy the luxury of walk-in closets and the convenience of direct access garages—comfort and style await you in your new home.",
  "property_home_floorplans_blurb": "Welcome to Patriot Pointe Townhomes in North Ogden, UT—where modern comfort meets inviting design. Choose from our spacious two and three-bedroom layouts, thoughtfully crafted to fit your lifestyle. Embrace the charm of community living and browse our available apartment homes to find the perfect floor plan tailored just for you!",
  "property_home_gallery_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, large, stylish two and three bedroom floor plans await you. Enjoy modern finishes, including stainless steel appliances and granite countertops, while spacious walk-in closets and direct access garages provide both convenience and privacy. Picture yourself living here—comfort and elegance blend seamlessly!",
  "property_home_neighborhood_blurb": "At Patriot Pointe Townhomes in North Ogden, experience spacious two and three-bedroom floor plans amidst a vibrant community. Adventure awaits with nearby attractions like the Ogden Botanical Gardens, the Treehouse Children's Museum, and Fair Buenaventura Park. Uncover local treasures and embrace a lifestyle of convenience and recreation!",
  "property_home_reviews_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, residents cherish the vibrant community atmosphere. One happy tenant shared, “The friendly neighbors and beautiful surroundings make this place feel like home!” Curious about what else our residents love? Check out their experiences and see why Patriot Pointe is the perfect fit!",
  "property_neighborhood_blurb": "At Patriot Pointe Townhomes in North Ogden, explore a vibrant community filled with unique attractions. From the historic Union Station to the enchanting Ogden Botanical Gardens, your new home is just steps away from adventure. Find nearby parks, engaging museums, and local shops that truly define the essence of our area.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, spacious two and three-bedroom layouts are designed for modern living. Enjoy unique finishes, stainless steel appliances, and luxurious walk-in closets. With attached garages and distinctive wood-style flooring, your ideal home blends comfort and style seamlessly. Your perfect space awaits!",
  "property_applynow_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, embrace stylish living with spacious two and three-bedroom layouts. Enjoy modern finishes, including granite countertops and stainless steel appliances, while reveling in the comfort of walk-in closets and direct access garages. Your perfect home awaits—lease online today! ",
  "property_contactus_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Whether you're seeking a cozy retreat or a family-friendly layout, we have it all. Need more information? Our leasing team is just a click away!",
  "property_faqs_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, spacious living awaits! Choose from thoughtfully designed two and three-bedroom floor plans tailored for comfort and style. Have questions? Our FAQs page has all the answers you need to connect with our vibrant community. Dive in and learn more today!",
  "property_floorplans_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, stylish living awaits you! Choose from spacious two and three-bedroom floor plans designed for comfort and convenience. Each layout offers a unique blend of modern amenities and thoughtful design. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_gallery_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, envision a life where modern elegance meets comfort. Choose from spacious two or three-bedroom layouts, each featuring stunning granite countertops, walk-in closets, and attached garages. Our exquisite amenities create an inviting atmosphere you’ll love to call home. Picture yourself living here!",
  "property_interactivemap_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, spacious two- and three-bedroom apartments invite you to experience modern living. Enjoy distinctive wood-style flooring, stainless steel appliances, and granite countertops, complemented by luxurious walk-in closets. Use our interactive community map to find your perfect home today and embrace comfort with convenience.",
  "property_pets_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, our pet-friendly atmosphere invites furry companions to thrive alongside you. Enjoy spacious living, vibrant surroundings, and a community that celebrates both comfort and companionship, making it the perfect place to call home for you and your beloved pets.",
  "property_referafriend_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, spacious two and three-bedroom floor plans await you and your friends. Great neighbors foster a vibrant community—refer a friend today and unlock the joy of living together in a welcoming environment that feels like home. Join us at Patriot Pointe!",
  "property_residentaccess_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, our spacious two- and three-bedroom layouts cater to your lifestyle needs. Access your resident portal effortlessly for seamless rent payments, maintenance requests, and community updates. Elevate your living experience in our welcoming neighborhood designed just for you!",
  "property_reviews_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, residents rave about their experience, with one noting, “It's a cozy community where neighbors quickly become friends.” See what our residents have to say about living at our community and discover the lifestyle that awaits you at Patriot Pointe!",
  "property_created_at": "1769723871681",
  "property_scheduletour_blurb": "At Patriot Pointe Townhomes in North Ogden, UT, spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to experience the vibrant community for yourself? Schedule a tour today and see what our residents love most about calling Patriot Pointe home!",
  "property_thankyou_blurb": "Thank you for reaching out to Patriot Pointe Townhomes in North Ogden, UT. With spacious two and three-bedroom floor plans, your ideal living space awaits. Our team is excited to assist you in finding the perfect home. Stay tuned for our call, and let's make your dream a reality!",
  "property_virtualtours_blurb": "Welcome to Patriot Pointe Townhomes in North Ogden, UT, where spacious two and three-bedroom layouts await you. Immerse yourself in our inviting community by taking a virtual tour today, and envision the perfect home tailored just for you. Your next adventure starts here—experience comfortable living redefined!",
  "property_copyright": "2026 All Rights Reserved. Patriot Pointe Townhomes",
  "property_seo_title_home": "Patriot Pointe Townhomes |  Apartments in North Ogden, UT",
  "property_seo_description_home": "Discover your perfect haven at Patriot Pointe Townhomes in North Ogden! Enjoy spacious layouts, modern finishes, and attached garages. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | North Ogden, UT Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Patriot Pointe Townhomes in North Ogden, UT. Choose from our spacious two and three-bedroom floor plans. Start your journey today!",
  "property_seo_title_amenities": "Amenities | North Ogden, UT Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Patriot Pointe Townhomes in North Ogden, UT, with spacious plans, modern finishes, and amenities that enhance your lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in North Ogden, UT",
  "property_seo_description_gallery": "Experience the charm of Patriot Pointe Townhomes in North Ogden, UT. Our spacious homes feature modern finishes and walk-in closets. Picture your new life!",
  "property_seo_title_virtualtours": "Virtual Tours | Patriot Pointe Townhomes Apartments",
  "property_seo_description_virtualtours": "Experience modern living at Patriot Pointe Townhomes in North Ogden, UT! Take a virtual tour of our spacious two and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Patriot Pointe Townhomes Apartments",
  "property_seo_description_interactivemap": "Unlock your ideal home at Patriot Pointe Townhomes in North Ogden, UT. Browse our spacious two and three-bedroom layouts with modern finishes today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Ogden, UT",
  "property_seo_description_neighborhood": "Uncover the charm of North Ogden at Patriot Pointe Townhomes. Dive into local favorites, scenic spots, and vibrant neighborhoods that surround your new home!",
  "property_seo_title_contact": "Contact Us | Patriot Pointe Townhomes",
  "property_seo_description_contact": "Contact Patriot Pointe Townhomes in North Ogden, UT! Our leasing team is here to help with inquiries on our spacious two and three-bedroom options.",
  "property_seo_title_faqs": "FAQs | Apartments in North Ogden, UT",
  "property_seo_description_faqs": "Uncover the comforts of Patriot Pointe Townhomes in North Ogden, UT. From spacious floor plans to modern finishes, our FAQs answer all your community queries!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Ogden, UT",
  "property_seo_description_reviews": "Experience modern living at Patriot Pointe Townhomes! Spacious layouts, stunning finishes, and resident satisfaction—read reviews on life in North Ogden today!",
  "property_seo_title_applynow": "Apply Now | Apartments in North Ogden, UT",
  "property_seo_description_applynow": "Discover luxury at Patriot Pointe Townhomes! Choose spacious 2-3 bedroom layouts with modern finishes and garages. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Patriot Pointe Townhomes",
  "property_seo_description_residentaccess": "Seamlessly manage your life at Patriot Pointe Townhomes! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Patriot Pointe Townhomes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Patriot Pointe Townhomes in North Ogden, UT, and enjoy a vibrant community together. Join us!",
  "property_seo_title_scheduletour": "Schedule a Tour | Patriot Pointe Townhomes",
  "property_seo_description_scheduletour": "Experience the charm of Patriot Pointe Townhomes in North Ogden, UT. Schedule your tour today and envision your future home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Patriot Pointe Townhomes",
  "property_seo_description_privacy": "Your trust is our priority at Patriot Pointe Townhomes in North Ogden, UT. Read our privacy policy to understand how we safeguard your information.",
  "property_seo_title_accessibility": "Website Accessibility | Patriot Pointe Townhomes",
  "property_seo_description_accessibility": "At Patriot Pointe Townhomes in North Ogden, UT, we prioritize accessibility for all. Experience comfortable living with a commitment to digital inclusion.",
  "property_seo_title_sitemap": "Sitemap | Patriot Pointe Townhomes",
  "property_seo_description_sitemap": "Navigate through Patriot Pointe Townhomes in North Ogden, UT. Uncover amenities, floor plans, and community highlights. Your future home awaits!",
  "property_seo_title_thankyou": "Thank You | Patriot Pointe Townhomes",
  "property_seo_description_thankyou": "Thank you for reaching out to Patriot Pointe Townhomes in North Ogden, UT! Expect a team member to connect with you soon about your new home.",
  "property_seo_title_pets": "Pet Policy | Apartments in North Ogden, UT",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786635911047",
  "amenities": [
    {
      "id": "ec_550c77f34da61603c17a91b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Peaceful Neighborhood",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4951f7fd0386911ae965315b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Stunning Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cf1c750e6988947cb4ba791",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_540eecb2e86a19f54ffa2ad9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da81cae16c779816ec2c0264",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Walking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a5d00448fbdd3f1c6485a4d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd3f047b4521064e375ddd62",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Brand New Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63e7fae50160653a80fe5a77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fdbdd34b5f142e2a8510a96",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "BBQ Area and Pergola",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a74fc0151964ac2eb41f2ec7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Direct Access Garages",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df0a5f13c3b996261049387e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Linen Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b38916ea31d93beaa5b34806",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd2bdbf61ee94d77a897b02b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1abaf7ab3b20f754d53eb816",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cf43450edc9b2fb30b921fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c8a8808f4577f4b8a51f275",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Distinctive Wood Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3187b16cf419666488818080",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Updated Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23006b8f3013f0eec0c377b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "external_id": "false",
      "title": "Washer Dryer In Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_23b4c540-1578-464d-af2c-c57dd783ad65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-e971-7188-90f0-010d113702f4.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with manicured lawns and walkways.",
        "public_id": "019d02d7-e971-7188-90f0-010d113702f4",
        "storage_key": "property/6767906449167019/019d02d7-e971-7188-90f0-010d113702f4.webp",
        "width": 1400,
        "height": 1049
      },
      "title": "Community",
      "description": "Modern townhomes with attractive exteriors, featuring spacious layouts and well-maintained grounds. Ideal for comfortable living.",
      "link": "",
      "alt_text": "Exterior view of townhome buildings with manicured lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16ada35e-4ffa-467a-9080-f3e39b51694c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-e853-75cb-8464-84d1f307e9bd.webp",
      "image_media": {
        "alt_text": "Courtyard with pathways and surrounding apartment buildings.",
        "public_id": "019d02d7-e853-75cb-8464-84d1f307e9bd",
        "storage_key": "property/6767906449167019/019d02d7-e853-75cb-8464-84d1f307e9bd.webp",
        "width": 1400,
        "height": 1049
      },
      "title": "Community",
      "description": "Experience the charm of our community with beautifully maintained courtyards and pathways, offering a serene environment.",
      "link": "",
      "alt_text": "Courtyard with pathways and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_513bc2fc-dee6-4058-9926-3a2d80b9cb3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-e04f-7019-9132-7f7837af7160.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with modern siding and brick accents.",
        "public_id": "019d02d7-e04f-7019-9132-7f7837af7160",
        "storage_key": "property/6767906449167019/019d02d7-e04f-7019-9132-7f7837af7160.webp",
        "width": 1400,
        "height": 1049
      },
      "title": "Community",
      "description": "Welcome home to these beautifully designed townhomes featuring a modern exterior with sleek siding and classic brick accents.",
      "link": "",
      "alt_text": "Exterior view of townhome buildings with modern siding and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a682b5ea-6b10-4205-ac77-f1af1174e5dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-df53-713f-8dfb-55fb7d74715c.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome apartments with dark grey siding, white trim, and dark asphalt roofs.",
        "public_id": "019d02d7-df53-713f-8dfb-55fb7d74715c",
        "storage_key": "property/6767906449167019/019d02d7-df53-713f-8dfb-55fb7d74715c.webp",
        "width": 1400,
        "height": 1049
      },
      "title": "Community",
      "description": "View the exterior of these modern townhome apartments, featuring a stylish combination of dark grey siding and white accents.",
      "link": "",
      "alt_text": "Exterior view of townhome apartments with dark grey siding, white trim, and dark asphalt roofs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e75332f-b421-4178-b7ca-33e16e658f46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-7d36-730f-8db3-b80f05e12388.webp",
      "image_media": {
        "alt_text": "Outdoor BBQ area with grill and seating, overlooking mountains.",
        "public_id": "019d02d7-7d36-730f-8db3-b80f05e12388",
        "storage_key": "property/6767906449167019/019d02d7-7d36-730f-8db3-b80f05e12388.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and gatherings with our community BBQ area, perfect for al fresco dining with a scenic mountain backdrop.",
      "link": "",
      "alt_text": "Outdoor BBQ area with grill and seating, overlooking mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eaacbca9-e697-42d5-a5d8-b9a94290ae15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-7c77-770b-ace1-2cc4f7f20258.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with wood chips, a bench, and townhouses in the background.",
        "public_id": "019d02d7-7c77-770b-ace1-2cc4f7f20258",
        "storage_key": "property/6767906449167019/019d02d7-7c77-770b-ace1-2cc4f7f20258.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a perfect spot for your furry friends to play and socialize in a safe, fenced-in environment.",
      "link": "",
      "alt_text": "A fenced-in dog park with wood chips, a bench, and townhouses in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97bfe626-76c3-454d-a0f9-cf39b72c3adf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-7373-7585-827a-8174afce9465.webp",
      "image_media": {
        "alt_text": "Gym with free weights, weight machines, and cardio equipment.",
        "public_id": "019d02d7-7373-7585-827a-8174afce9465",
        "storage_key": "property/6767906449167019/019d02d7-7373-7585-827a-8174afce9465.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring free weights, weight machines, and cardio equipment for residents.",
      "link": "",
      "alt_text": "Gym with free weights, weight machines, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb45fbee-4616-443e-846e-9b47a07384eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-7488-7667-be1f-3336c69838b4.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and weight machines in a well-lit apartment complex gym.",
        "public_id": "019d02d7-7488-7667-be1f-3336c69838b4",
        "storage_key": "property/6767906449167019/019d02d7-7488-7667-be1f-3336c69838b4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and weight machines in a well-lit apartment complex gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d834ad7-6728-4152-8774-34f13f71ef2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-73ab-738e-93a7-195263435602.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machine overlooking mountains.",
        "public_id": "019d02d7-73ab-738e-93a7-195263435602",
        "storage_key": "property/6767906449167019/019d02d7-73ab-738e-93a7-195263435602.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and weight machines with stunning mountain views.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machine overlooking mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ee2546b5-1102-4852-8059-f7049328210e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-6c56-734c-9d7d-ec31fc941864.webp",
      "image_media": {
        "alt_text": "Dumbbell rack and weight bench in a gym with blue patterned wallpaper and large mirrors.",
        "public_id": "019d02d7-6c56-734c-9d7d-ec31fc941864",
        "storage_key": "property/6767906449167019/019d02d7-6c56-734c-9d7d-ec31fc941864.webp",
        "width": 1024,
        "height": 1535
      },
      "title": "Community",
      "description": "Stay active at our state-of-the-art fitness center, equipped with a wide range of free weights and cardio machines.",
      "link": "",
      "alt_text": "Dumbbell rack and weight bench in a gym with blue patterned wallpaper and large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb38ac55-01c7-4666-9202-7fd8ca3f9517",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-5c91-73d3-bfd3-49d4b1ad1ed8.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs.",
        "public_id": "019d02d7-5c91-73d3-bfd3-49d4b1ad1ed8",
        "storage_key": "property/6767906449167019/019d02d7-5c91-73d3-bfd3-49d4b1ad1ed8.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Apartment",
      "description": "A cozy dining area featuring a round wooden table with four upholstered chairs and decorative wall art.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81ac776b-9676-41e5-82d1-f6639396fc73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-5095-74f6-a74e-502fbeb08150.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, coffee table, and large windows overlooking a neighborhood.",
        "public_id": "019d02d7-5095-74f6-a74e-502fbeb08150",
        "storage_key": "property/6767906449167019/019d02d7-5095-74f6-a74e-502fbeb08150.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and brightly lit living room featuring a comfortable white sofa, a rustic coffee table, and decorative accents. Large windows offer views of the surrounding neighborhood.",
      "link": "",
      "alt_text": "Modern living room with white sofa, coffee table, and large windows overlooking a neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2134f28f-6dab-4ba7-a7d2-d38d94cc6730",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-42be-7309-84d0-7aad9fbf7cec.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, orange accent pillows, and a view into the bathroom.",
        "public_id": "019d02d7-42be-7309-84d0-7aad9fbf7cec",
        "storage_key": "property/6767906449167019/019d02d7-42be-7309-84d0-7aad9fbf7cec.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with plush bedding and decorative orange pillows. An adjacent bathroom is visible through the open doorway.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, orange accent pillows, and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d903f8f-3b0e-4bdc-b25e-058ecc74aa3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-4d75-7488-a994-4d257948ee5e.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with a large coffee table, plush sofa, and armchairs in a modern lounge.",
        "public_id": "019d02d7-4d75-7488-a994-4d257948ee5e",
        "storage_key": "property/6767906449167019/019d02d7-4d75-7488-a994-4d257948ee5e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Comfortable seating area with a large coffee table, plush sofa, and armchairs in a modern lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94f199a9-ab2d-4a93-9209-ad4edc31d8c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-3d91-734d-b290-9b3d721ddf80.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table and island seating.",
        "public_id": "019d02d7-3d91-734d-b290-9b3d721ddf80",
        "storage_key": "property/6767906449167019/019d02d7-3d91-734d-b290-9b3d721ddf80.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living and dining area seamlessly integrated with a modern kitchen, featuring an island with bar stools and ample counter space.",
      "link": "",
      "alt_text": "Living room and kitchen area with dining table and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0993bda3-5880-4fc5-aff1-bb5c6eea8cb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-3c87-7198-afa6-b8c23f09c0f0.webp",
      "image_media": {
        "alt_text": "Living room with two blue chairs, sofa, coffee table, and stairs.",
        "public_id": "019d02d7-3c87-7198-afa6-b8c23f09c0f0",
        "storage_key": "property/6767906449167019/019d02d7-3c87-7198-afa6-b8c23f09c0f0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring comfortable seating, a coffee table, and access to stairs, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with two blue chairs, sofa, coffee table, and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0acdcd48-2a20-4f55-b18b-132c1b05eb92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d7-3510-7175-8bab-f618244997c9.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a coffee table, accent chairs, and a view into the kitchen and dining area.",
        "public_id": "019d02d7-3510-7175-8bab-f618244997c9",
        "storage_key": "property/6767906449167019/019d02d7-3510-7175-8bab-f618244997c9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this inviting living space, featuring comfortable seating, a stylish coffee table, and an open-concept flow into the dining area and kitchen.",
      "link": "",
      "alt_text": "Bright and airy living room with a coffee table, accent chairs, and a view into the kitchen and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8be51158-1001-442f-93f4-35325807e4e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Slackwater Ogden",
      "poi_type": "Restaurants",
      "poi_address": "209 24th St, Ogden, UT 84401, USA",
      "poi_short_description": "Spare but comfy pizza parlor offering original pie combos, pub grub, robust beer list & live music.",
      "poi_long_description": "People say this pizza restaurant offers a wide variety of unique and delicious pizzas, including the hot honey dp and California sunrise, as well as good wings and sandwiches. They highlight the great beer selection, reasonable prices, and fun, lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-8c52-704c-84eb-fd1107a655c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-8c52-704c-84eb-fd1107a655c7",
        "storage_key": "property/6767906449167019/019d02d6-8c52-704c-84eb-fd1107a655c7.webp",
        "width": 1134,
        "height": 1280
      },
      "poi_business_url": "http://slackwaterpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6352609519359304441&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slackwater-ogden",
      "poi_latitude": "41.22263239999999",
      "poi_longitude": "-111.9756676",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-399-0637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e6-739e-b693-e567cb4e96c8",
        "storage_key": "property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHx6kTMEOU4cR-SItRrMAKVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_b5b278a8-fb44-4718-a1a1-23cd038142cc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1120 Washington Blvd, Ogden, UT 84404, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious cob salads, chicken sandwiches, and lemonade. They highlight the fast service and friendly staff. They also like the efficient drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-8ace-7266-b5c3-65875e4ed0dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-8ace-7266-b5c3-65875e4ed0dd",
        "storage_key": "property/6767906449167019/019d02d6-8ace-7266-b5c3-65875e4ed0dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ut/ogden?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1308427479720233000&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "41.2455452",
      "poi_longitude": "-111.9693804",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-394-1992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e6-739e-b693-e567cb4e96c8",
        "storage_key": "property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTFigbsOU4cRKIgVR9x3KBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2928a022-eb39-496f-bac2-c44d8c19e804",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Jeremiah's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1307 W 12th St, Marriott-Slaterville, UT 84404, USA",
      "poi_short_description": "Sleek, hunting-lodge-style canteen for classic American comfort food from burgers to fish 'n' chips.",
      "poi_long_description": "People say this restaurant serves delicious breakfast, burgers, and chicken fried steak, and is known for its giant scones and cinnamon rolls. They also highlight the large portions, reasonable prices, and rustic, mountain-themed atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-8c38-72dc-a8f4-de932cd792ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-8c38-72dc-a8f4-de932cd792ad",
        "storage_key": "property/6767906449167019/019d02d6-8c38-72dc-a8f4-de932cd792ad.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.jeremiahsutah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15381010605721721475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jeremiahs-restaurant",
      "poi_latitude": "41.2442175",
      "poi_longitude": "-112.011716",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-394-3273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e6-739e-b693-e567cb4e96c8",
        "storage_key": "property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWqXqHUOU4cRgxqPYKdTdNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f5deb8a7-fc07-4a44-8e6f-e3b4488c63c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Prairie Schooner Steak House",
      "poi_type": "Restaurants",
      "poi_address": "445 Park Blvd, Ogden, UT 84401, USA",
      "poi_short_description": "Steaks, seafood & sandwiches in an Old West-inspired setting with covered-wagon dining & taxidermy.",
      "poi_long_description": "People say this steakhouse offers delicious chicken fried steak, ribs, and fried mushrooms. They also highlight the fun, unique dining experience in covered wagons, the cozy atmosphere, and the friendly, attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-8ba9-72e8-af08-6f4e56089ea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-8ba9-72e8-af08-6f4e56089ea0",
        "storage_key": "property/6767906449167019/019d02d6-8ba9-72e8-af08-6f4e56089ea0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.prairieschoonerrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15646706194891041920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prairie-schooner-steak-house",
      "poi_latitude": "41.2343881",
      "poi_longitude": "-111.968879",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-392-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e6-739e-b693-e567cb4e96c8",
        "storage_key": "property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TAQwcYOU4cRgGxia2JEJNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_5acbdc18-382b-40ab-ac51-032e5c24773f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Timbermine Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1701 Park Blvd, Ogden, UT 84401, USA",
      "poi_short_description": "Wood-lined, family-friendly chophouse with a mining theme delivers steaks, seafood & draft beers.",
      "poi_long_description": "People say this steakhouse serves delicious prime rib, ribeye, and fried mushrooms, and offers a variety of kids' meals. They highlight the fun, rustic, and unique atmosphere, and the fair prices. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-9175-717a-adfd-005c43df7ff0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-9175-717a-adfd-005c43df7ff0",
        "storage_key": "property/6767906449167019/019d02d6-9175-717a-adfd-005c43df7ff0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.timbermine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5906538057952201576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "timbermine-steakhouse",
      "poi_latitude": "41.2378943",
      "poi_longitude": "-111.9332252",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-393-2155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e6-739e-b693-e567cb4e96c8",
        "storage_key": "property/6767906449167019/019d02d6-50e6-739e-b693-e567cb4e96c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-fJ9DwJU4cRaAuRzBE9-FE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a0205d7c-dbf2-4431-9187-3ccd7a701a0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "984 Wall Ave, Ogden, UT 84404, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products, including lawn care items, and has competitive prices. They also highlight the helpful and friendly staff, and the clean and well-organized store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-92ef-7744-8d4c-efdbab894a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-92ef-7744-8d4c-efdbab894a86",
        "storage_key": "property/6767906449167019/019d02d6-92ef-7744-8d4c-efdbab894a86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Ogden/UT/Ogden/84404/4411?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11244832665682138176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "41.2470967",
      "poi_longitude": "-111.9761062",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-393-0106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-55cf-7659-b992-d9b77c831dd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-55cf-7659-b992-d9b77c831dd3",
        "storage_key": "property/6767906449167019/019d02d6-55cf-7659-b992-d9b77c831dd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkb2GQ5gOU4cRQFSxVLurDZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4635278d-1003-45cc-a06b-0a56a6c48bd6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "205 W 12th St, Ogden, UT 84404, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of products, including a large bulk food selection, fresh produce, and meat. They highlight the great prices and the 24-hour availability. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-92ef-7744-8d4c-ebf4a7b726c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-92ef-7744-8d4c-ebf4a7b726c2",
        "storage_key": "property/6767906449167019/019d02d6-92ef-7744-8d4c-ebf4a7b726c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8698120870048981074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "41.242199",
      "poi_longitude": "-111.981496",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-781-2501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50dd-704c-bf1b-10c78b48a010",
        "storage_key": "property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPT0ZQ5cOU4cRUmCuwNjutXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_eba347db-c3d4-42b2-810a-b567fa58c2d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Smith's Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2434 N Washington Rd Blvd, North Ogden, UT 84414, USA",
      "poi_short_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_long_description": "People say this grocery store offers a wide selection of products, including fresh produce, sushi, and a well-stocked pharmacy. They also highlight the good prices, weekly sales, and fuel points program, as well as the clean and organized store.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d5-e7eb-75c9-bfeb-a914b0ba6b99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-e7eb-75c9-bfeb-a914b0ba6b99",
        "storage_key": "property/6767906449167019/019d02d5-e7eb-75c9-bfeb-a914b0ba6b99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/ut/north-ogden/north-ogden-marketplace/706/00279?cid=loc_70600279_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15633685200528296166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "smiths-marketplace",
      "poi_latitude": "41.3028666",
      "poi_longitude": "-111.966353",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-917-1977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50dd-704c-bf1b-10c78b48a010",
        "storage_key": "property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWhjNI4MU4cR5kjF69sB9tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f142848c-18f5-4216-ba89-cc74ac8bd1ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Smith's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1485 Harrison Blvd, Ogden, UT 84404, USA",
      "poi_short_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_long_description": "People say this grocery store offers fresh produce, high-quality meat, and a good selection of houseplants. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the self-checkout can be frustrating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-95e6-7329-b92f-69441b784e22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-95e6-7329-b92f-69441b784e22",
        "storage_key": "property/6767906449167019/019d02d6-95e6-7329-b92f-69441b784e22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/ut/ogden/1485-harrison-blvd-ogden-ut/706/00131?cid=loc_70600131_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12763025601258268895&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "smiths",
      "poi_latitude": "41.240981",
      "poi_longitude": "-111.9467113",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-621-0234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50dd-704c-bf1b-10c78b48a010",
        "storage_key": "property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16Ns3DUJU4cR3yg3tilgH7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2ffb9e31-f53e-4235-a2e6-b11bc1f004f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Rancho Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "905 26th St #99A, Ogden, UT 84401, USA",
      "poi_short_description": "Meat, produce, and seafood supermarket chain featuring a bakery and a restaurant.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and baked goods. They also highlight the great prices, especially on sale items, and the clean, well-stocked store.\n\nOther reviews mention the service can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-98cb-758d-bcf5-170f65f46291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-98cb-758d-bcf5-170f65f46291",
        "storage_key": "property/6767906449167019/019d02d6-98cb-758d-bcf5-170f65f46291.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ranchomarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12567498346395247155&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rancho-markets",
      "poi_latitude": "41.2181792",
      "poi_longitude": "-111.9562964",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-409-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50dd-704c-bf1b-10c78b48a010",
        "storage_key": "property/6767906449167019/019d02d6-50dd-704c-bf1b-10c78b48a010.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr94huysPU4cRM6IyHCm5aK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d9d76fd0-e0e5-4291-83d7-fa79035c10a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Main Library - Weber County Library System",
      "poi_type": "Education",
      "poi_address": "2464 Jefferson Ave, Ogden, UT 84401, USA",
      "poi_short_description": "Public library offering a wide selection of books and other resources, plus a cafe, and activities.",
      "poi_long_description": "People say this public library offers a wide variety of books, including board books, and has free computer, printing, and wifi services. They highlight the fun crafts, interesting classes, and activities offered each month, as well as the cool maker space and study areas. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-99fd-76e8-b795-24d16f543c71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-99fd-76e8-b795-24d16f543c71",
        "storage_key": "property/6767906449167019/019d02d6-99fd-76e8-b795-24d16f543c71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.weberpl.lib.ut.us/locations-and-hours/main-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=13109954215640259905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-library---weber-county-library-system",
      "poi_latitude": "41.221085",
      "poi_longitude": "-111.964452",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-337-2632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-560a-716d-bd85-b91722a4ece3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-560a-716d-bd85-b91722a4ece3",
        "storage_key": "property/6767906449167019/019d02d6-560a-716d-bd85-b91722a4ece3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ13DrL9gOU4cRQV3fTObp77U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ce827317-2dfd-4f4b-8ff6-ffe372187594",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "North Branch - Weber County Library System",
      "poi_type": "Education",
      "poi_address": "475 E 2600 N, North Ogden, UT 84414, USA",
      "poi_short_description": "Public library with a peaceful environment where people say the staff is helpful.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-9aae-743b-9794-3ca42cf22b97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-9aae-743b-9794-3ca42cf22b97",
        "storage_key": "property/6767906449167019/019d02d6-9aae-743b-9794-3ca42cf22b97.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.weberpl.lib.ut.us/locations-and-hours/north-branch",
      "poi_directions_map_url": "https://maps.google.com/?cid=225764507925121368&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-branch---weber-county-library-system",
      "poi_latitude": "41.3051935",
      "poi_longitude": "-111.965529",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-337-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-560a-716d-bd85-b91722a4ece3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-560a-716d-bd85-b91722a4ece3",
        "storage_key": "property/6767906449167019/019d02d6-560a-716d-bd85-b91722a4ece3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpeobMpAMU4cRWInEsZ8TIgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_40aacb0d-87a7-49d4-b837-fed749e43635",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Ogden's George S. Eccles Dinosaur Park",
      "poi_type": "Entertainment",
      "poi_address": "1544 Park Blvd, Ogden, UT 84401, USA",
      "poi_short_description": "8.5-acre park featuring more than 100 dinosaur sculptures, plus a museum with hands-on activities.",
      "poi_long_description": "People say this museum offers a wide variety of dinosaur fossils, life-sized dinosaur statues, and a gem and mineral exhibit. They highlight the fun and educational experience for families, with activities like gem digging and a playground, and the spacious grounds with picnic areas and walking trails. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-1581-729d-aed8-1a414ddaa2ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-1581-729d-aed8-1a414ddaa2ef",
        "storage_key": "property/6767906449167019/019d02d6-1581-729d-aed8-1a414ddaa2ef.webp",
        "width": 640,
        "height": 478
      },
      "poi_business_url": "http://www.dinosaurpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11697511755166289778&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ogdens-george-s-eccles-dinosaur-park",
      "poi_latitude": "41.237827",
      "poi_longitude": "-111.937941",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-393-3466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5ac8-72a5-8305-f9d2e3d42103.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5ac8-72a5-8305-f9d2e3d42103",
        "storage_key": "property/6767906449167019/019d02d6-5ac8-72a5-8305-f9d2e3d42103.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91QGTjoJU4cRco-kGvfoVaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bbbce9cb-1e06-4471-9356-28cf7fdf4bc0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Entertainment",
      "poi_address": "Union Station, 2501 Wall Ave, Ogden, UT 84401, USA",
      "poi_short_description": "Historic 1920s train station converted to an indoor marketplace with museums, art gallery & eatery.",
      "poi_long_description": "People say this rail museum offers a fantastic collection of trains, vintage cars, and firearms, as well as model railroads and art galleries. They highlight the incredible value, fun experience for families, and the beautiful, historic atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-10f5-75d7-b300-87c94bdc7f2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-10f5-75d7-b300-87c94bdc7f2e",
        "storage_key": "property/6767906449167019/019d02d6-10f5-75d7-b300-87c94bdc7f2e.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.ogdencity.com/1337/Visit",
      "poi_directions_map_url": "https://maps.google.com/?cid=1648535471261723673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "41.2207103",
      "poi_longitude": "-111.9797967",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-629-8680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5ac8-72a5-8305-f9d2e3d42103.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5ac8-72a5-8305-f9d2e3d42103",
        "storage_key": "property/6767906449167019/019d02d6-5ac8-72a5-8305-f9d2e3d42103.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJt7a-LeEOU4cRGawv3EbG4BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6aee38d7-413d-4d9a-a56a-c2013df5f93f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Treehouse Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "347 22nd St, Ogden, UT 84401, USA",
      "poi_short_description": "Reading-oriented museum encouraging kids to \"step into a story\" via hand-on activities & exhibits.",
      "poi_long_description": "People say this children's museum offers a wide variety of engaging, hands-on exhibits and activities, including themed play areas, a theater, and a craft area. They highlight the reasonable admission price and the fun, educational, and imaginative experience for children of all ages. They also like the clean, well-maintained facilities and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-1602-70dc-8505-ceb93ec452a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-1602-70dc-8505-ceb93ec452a0",
        "storage_key": "property/6767906449167019/019d02d6-1602-70dc-8505-ceb93ec452a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.treehousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8031847823320128345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "treehouse-childrens-museum",
      "poi_latitude": "41.2265046",
      "poi_longitude": "-111.9718977",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-394-9663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5ac8-72a5-8305-f9d2e3d42103.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5ac8-72a5-8305-f9d2e3d42103",
        "storage_key": "property/6767906449167019/019d02d6-5ac8-72a5-8305-f9d2e3d42103.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5y-mx9wOU4cRWZv9bgrbdm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_251169b5-6373-4d36-86ee-3811c55ee294",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Christmas Village",
      "poi_type": "Entertainment",
      "poi_address": "343 25th St, Ogden, UT 84401, USA",
      "poi_short_description": "Family-friendly destination decorated with festive lights and charming miniature houses.",
      "poi_long_description": "People say this theme park offers a beautiful Christmas light display with Ogden-themed houses, hot chocolate vendors, and a train ride for kids. They highlight the fun, relaxing, and festive atmosphere, and the many photo opportunities. They also like that it's free and great for the whole family.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a0c9-74af-acef-f40738cf9868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a0c9-74af-acef-f40738cf9868",
        "storage_key": "property/6767906449167019/019d02d6-a0c9-74af-acef-f40738cf9868.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5211862788024054480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christmas-village",
      "poi_latitude": "41.219902",
      "poi_longitude": "-111.9720252",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-997-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fV45N4OU4cR0DJAkpdBVEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_602a0f0a-6d4e-40e0-b100-a38fd10fac38",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Lindquist Field",
      "poi_type": "Entertainment",
      "poi_address": "2330 Lincoln Ave, Ogden, UT 84401, USA",
      "poi_short_description": "Baseball ground with mountain views, featuring the home team Ogden Raptors.",
      "poi_long_description": "People say this stadium offers a fun atmosphere and a well-designed outdoor ballpark with comfortable seating and plenty of bathrooms. They highlight the scenic mountain backdrop, the clear scoreboard and speakers, and the friendly staff. They also like the reasonable ticket prices and the sense of community that baseball brings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a0e3-703a-83bd-d387cf607c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a0e3-703a-83bd-d387cf607c37",
        "storage_key": "property/6767906449167019/019d02d6-a0e3-703a-83bd-d387cf607c37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ogden-raptors.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12581531415153888045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lindquist-field",
      "poi_latitude": "41.2242941",
      "poi_longitude": "-111.9749785",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-393-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-c9e6-75e2-8316-2aa24edea86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-c9e6-75e2-8316-2aa24edea86d",
        "storage_key": "property/6767906449167019/019d02d6-c9e6-75e2-8316-2aa24edea86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVXdQY90OU4cRLUuqiimUmq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2bb5fccb-9e04-4c60-b06c-82128c396d87",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2261 Kiesel Ave #200, Ogden, UT 84401, USA",
      "poi_short_description": "Gym with a basketball court, a pool, and a turf functional training area, plus a kids' club.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, amenities like a pool, sauna, and steam room, and a running track. They also highlight the friendly and helpful staff, and the welcoming atmosphere.\n\nSome reviews mention the pool can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a1a7-713a-bbc5-2e8cb7e01110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a1a7-713a-bbc5-2e8cb7e01110",
        "storage_key": "property/6767906449167019/019d02d6-a1a7-713a-bbc5-2e8cb7e01110.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/ogden-gym-on-kiesel-ave/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10671556619112368639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "41.225335",
      "poi_longitude": "-111.9718435",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-399-5861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN3wE84wPU4cR_0mpajT8GJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b5f81e41-d2d5-47e4-985c-db074dd48365",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1150 Washington Blvd, Ogden, UT 84404, USA",
      "poi_short_description": "Friendly chain gym offering classes and kid care, along with an indoor pool and a hot tub.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including a pool, sauna, steam room, and hot tub, and the staff is friendly and helpful.\n\nOther reviews mention the equipment can be in disrepair and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a187-7758-b207-031aba3b1663.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a187-7758-b207-031aba3b1663",
        "storage_key": "property/6767906449167019/019d02d6-a187-7758-b207-031aba3b1663.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ut/ogden/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12506941640114628489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "41.245158",
      "poi_longitude": "-111.967953",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-621-8272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61EvfLsOU4cRieeSNSiVka0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_219c9cce-bd20-4dee-9201-67344f65e6a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Farr West Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 N 2000 W, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a6c1-747a-9579-a9327402efa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a6c1-747a-9579-a9327402efa2",
        "storage_key": "property/6767906449167019/019d02d6-a6c1-747a-9579-a9327402efa2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://farrwestanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4741180189320182791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "farr-west-animal-hospital",
      "poi_latitude": "41.282384",
      "poi_longitude": "-112.0273456",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-731-0511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTC4N54NU4cRB3yMKEMOzEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_342b7146-581f-4b6c-a0c8-ea780e23427b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Ben Lomond Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "1380 N, 1380 US-89, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a831-717a-93f5-3e6889782471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a831-717a-93f5-3e6889782471",
        "storage_key": "property/6767906449167019/019d02d6-a831-717a-93f5-3e6889782471.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://www.clinicshere.com/ben-lomond-animal-clinic-ogden-ut/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674669333307213086&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ben-lomond-animal-clinic",
      "poi_latitude": "41.2839769",
      "poi_longitude": "-111.9869248",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-782-9679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSbSjVoMU4cRHkUEyOKePRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f06c5d1c-9868-4292-ba4c-fc86810dfc33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Brookside Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "690 Wall Ave, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a7a9-708e-b684-93bf63e7a776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a7a9-708e-b684-93bf63e7a776",
        "storage_key": "property/6767906449167019/019d02d6-a7a9-708e-b684-93bf63e7a776.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.brooksidepets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14847840927651578774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brookside-animal-hospital",
      "poi_latitude": "41.2520574",
      "poi_longitude": "-111.9775119",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-399-5897",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yBoEZ8OU4cRlsMtDqggDs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_39c7bed2-c501-4824-b176-c986bea35be9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "North Ogden Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1580 N Washington Blvd, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-a736-76c2-8ce0-c688fa283771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a736-76c2-8ce0-c688fa283771",
        "storage_key": "property/6767906449167019/019d02d6-a736-76c2-8ce0-c688fa283771.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.northogdenanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=947566331769533289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-ogden-animal-hospital",
      "poi_latitude": "41.2866294",
      "poi_longitude": "-111.9686425",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-782-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8l7k2UMU4cRaTM-7o5uJg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_508610a1-c2ef-408a-b40f-40b2872ccded",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "145 W 12th St, Ogden, UT 84404, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-acde-7488-898a-8b23cb1d34f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-acde-7488-898a-8b23cb1d34f6",
        "storage_key": "property/6767906449167019/019d02d6-acde-7488-898a-8b23cb1d34f6.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ut/ogden/145-w-12th-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12616608817768590631&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "41.24390409999999",
      "poi_longitude": "-111.9808477",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 385-206-8811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSonQSwJU4cRJ20oxd8yF68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_cb394204-41c1-4c01-ad56-5edfa5cab411",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of North Ogden - Commons",
      "poi_type": "Health and Wellness",
      "poi_address": "2574 N Washington Blvd, North Ogden, UT 84414, USA",
      "poi_short_description": "Chain hair salon for men and boys specializing in haircuts with steamed towels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-ad0d-7784-b8cc-55d80915590e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-ad0d-7784-b8cc-55d80915590e",
        "storage_key": "property/6767906449167019/019d02d6-ad0d-7784-b8cc-55d80915590e.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://sportclips.com/us-ut-northogden-ut127?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=11807964470182686266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-north-ogden---commons",
      "poi_latitude": "41.30506889999999",
      "poi_longitude": "-111.9676304",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-782-9471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDb5L55EMU4cROi6s1R9R3qM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_2d0b9e01-c86c-4bc1-b8a1-ac76e6180fc6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "455 N Washington Blvd Suite 432, Harrisville, UT 84404, USA",
      "poi_short_description": "Clean gym with a range of equipment.",
      "poi_long_description": "People say this gym offers excellent cardio and weight equipment. They highlight the clean facilities and friendly atmosphere. They also like the knowledgeable and supportive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-af2f-76ec-93ff-6b5cb70683c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-af2f-76ec-93ff-6b5cb70683c6",
        "storage_key": "property/6767906449167019/019d02d6-af2f-76ec-93ff-6b5cb70683c6.webp",
        "width": 989,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/harrisville-utah-5306/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7024251832820424273&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "41.2674232",
      "poi_longitude": "-111.9704076",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 385-600-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMU6qzusNU4cRUd4lbNMne2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_09acf0e0-9683-4a3f-9b3b-da329a876004",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Inspire Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "1960 Wall Ave, Ogden, UT 84401, USA",
      "poi_short_description": "Sprawling gym with classes and lessons for adults and kids in tumbling and gymnastics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-ae1d-7229-bfef-d5ec33b7644f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-ae1d-7229-bfef-d5ec33b7644f",
        "storage_key": "property/6767906449167019/019d02d6-ae1d-7229-bfef-d5ec33b7644f.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://inspiregymnasticsutah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15405258378030277452&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "inspire-gymnastics",
      "poi_latitude": "41.2317486",
      "poi_longitude": "-111.9775622",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 385-289-2962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-560a-716d-bd85-b91722a4ece3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-560a-716d-bd85-b91722a4ece3",
        "storage_key": "property/6767906449167019/019d02d6-560a-716d-bd85-b91722a4ece3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOzoYPeoOU4cRTOOaz994ytU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_97ba1018-95c3-4de5-a67d-09c153878443",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Ogden Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1750 Monroe Blvd, Ogden, UT 84401, USA",
      "poi_short_description": "Peaceful landscaped gardens with distinct sections, grilling stations & a lawn hosting events.",
      "poi_long_description": "People say this botanical garden offers beautiful flowers, plants, and a rose garden, as well as walking trails along the river. They highlight the peaceful and tranquil vibe, and the great opportunities for family pictures. They also like the educational programs and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-b350-7789-9625-aa54d2d46cb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-b350-7789-9625-aa54d2d46cb1",
        "storage_key": "property/6767906449167019/019d02d6-b350-7789-9625-aa54d2d46cb1.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://ogdenbotanicalgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10422653472711925480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ogden-botanical-gardens",
      "poi_latitude": "41.2351739",
      "poi_longitude": "-111.9535463",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-399-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5f8a-7799-a3b3-cf2f401a7f78",
        "storage_key": "property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZg6vMwOU4cR6F78oRy0pJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_05d2e4f0-a701-46c1-8aad-c0b998e76072",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "North Ogden Parks & Recreation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2705 N 550 E, Ogden, UT 84414, USA",
      "poi_short_description": "Park with a children's playground, a skate park, sports facilities, and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-b380-76a8-97ed-6f1b5b2e8ad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-b380-76a8-97ed-6f1b5b2e8ad1",
        "storage_key": "property/6767906449167019/019d02d6-b380-76a8-97ed-6f1b5b2e8ad1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.northogdenrecreation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1268889512343505274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-ogden-parks--recreation",
      "poi_latitude": "41.3086574",
      "poi_longitude": "-111.9636637",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-737-0587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5f8a-7799-a3b3-cf2f401a7f78",
        "storage_key": "property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK62ZjZAMU4cRegl04kkAnBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d35aa61c-307d-4244-9b00-5fe1de7e1657",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Barker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2375 Fruitland Dr, North Ogden, UT 84414, USA",
      "poi_short_description": "Newer park with an amphitheater for concerts and play performances, plus hilly areas for sledding in winter and an area for picnics.",
      "poi_long_description": "People say this park is beautiful, clean, and well-maintained, with spacious parking and a playground. They highlight the park's suitability for events, concerts, and family gatherings, and appreciate the covered tables, nearby restrooms, and easy online reservation system. They also like the Christmas lights and Santa experience during the holiday season.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-2a73-7778-a4e8-2c255538df04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-2a73-7778-a4e8-2c255538df04",
        "storage_key": "property/6767906449167019/019d02d6-2a73-7778-a4e8-2c255538df04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northogdencity.com/parksrec/page/barker-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11156038573023025562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barker-park",
      "poi_latitude": "41.3026601",
      "poi_longitude": "-111.9511313",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-737-0587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5f8a-7799-a3b3-cf2f401a7f78",
        "storage_key": "property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTxabX4LU4cRmtmXlfk10po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c30d0129-c967-4cdd-8028-aacbfbfba9d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Fort Buenaventura Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2450 A Ave, Ogden, UT 84401, USA",
      "poi_short_description": "Fur-trading & battle history, Native American artifacts, hiking trails, fishing & a visitor center.",
      "poi_long_description": "People say this park offers beautiful scenery, a disc golf course, and areas for dogs to run and play. They highlight the peaceful and relaxing vibe, and the opportunity to escape the city. They also like the historic elements and the well-maintained paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-b5cf-72bc-9cad-fa8c90f18e0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-b5cf-72bc-9cad-fa8c90f18e0c",
        "storage_key": "property/6767906449167019/019d02d6-b5cf-72bc-9cad-fa8c90f18e0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wcparksrec.com/fortbuenaventura",
      "poi_directions_map_url": "https://maps.google.com/?cid=9525548521859371186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-buenaventura-park",
      "poi_latitude": "41.2204023",
      "poi_longitude": "-111.9882658",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-399-8099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5f8a-7799-a3b3-cf2f401a7f78",
        "storage_key": "property/6767906449167019/019d02d6-5f8a-7799-a3b3-cf2f401a7f78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7gO5PoOU4cRstAsgOmLMYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6026d537-ce04-4579-856d-eddf7248ae77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "The Barn Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "305 W Pleasant View Dr, Ogden, UT 84414, USA",
      "poi_short_description": "Challenging golf course set amid views of the mountains.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout with beautiful mountain views. They highlight the well-maintained course conditions and the friendly staff. They also like the online booking system, which allows single players to reserve tee times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-b555-7098-9c86-7d24c7bc2b7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-b555-7098-9c86-7d24c7bc2b7e",
        "storage_key": "property/6767906449167019/019d02d6-b555-7098-9c86-7d24c7bc2b7e.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.thebarngolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15439783429017064341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-barn-golf-course",
      "poi_latitude": "41.31206510000001",
      "poi_longitude": "-111.9840316",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 801-206-9865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-cc2f-73da-9dbb-bf4245fb02d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-cc2f-73da-9dbb-bf4245fb02d0",
        "storage_key": "property/6767906449167019/019d02d6-cc2f-73da-9dbb-bf4245fb02d0.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3D8RcIMU4cRlVOGpzkhRdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_690f54f7-2479-4ff9-a771-dd5365e9a027",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Ogden",
      "poi_type": "Transportation & Transit",
      "poi_address": "2350 Wall Ave, Ogden, UT 84401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-ba3d-711a-8e05-0bf5422f3c3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-ba3d-711a-8e05-0bf5422f3c3b",
        "storage_key": "property/6767906449167019/019d02d6-ba3d-711a-8e05-0bf5422f3c3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16227755894043847217&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ogden",
      "poi_latitude": "41.2244871",
      "poi_longitude": "-111.9807137",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-ccfb-7199-ad46-881486308345.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-ccfb-7199-ad46-881486308345",
        "storage_key": "property/6767906449167019/019d02d6-ccfb-7199-ad46-881486308345.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXTB4zD_UocRMSo83gGSNOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_2b6d5948-c5d9-4aeb-9308-fede6461a8f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Nutraceutical Corporation, Better Being Co., Wellness Brands",
      "poi_type": "Major Employers & Offices",
      "poi_address": "550 W 2nd St, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-baa1-7162-ac40-8cd5a71a706e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-baa1-7162-ac40-8cd5a71a706e",
        "storage_key": "property/6767906449167019/019d02d6-baa1-7162-ac40-8cd5a71a706e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nutraceutical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2918387839283945683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nutraceutical-corporation-better-being-co-wellness-brands",
      "poi_latitude": "41.260079",
      "poi_longitude": "-111.9913884",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-334-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xJsNx0MU4cR0-BWDUcygCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7bef4f9b-f431-4b06-8bb7-149108da2a3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Vocational Rehabilitation (VR)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 25th St # 200, Ogden, UT 84401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-bbc1-706b-bad2-ca329edbcb93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-bbc1-706b-bad2-ca329edbcb93",
        "storage_key": "property/6767906449167019/019d02d6-bbc1-706b-bad2-ca329edbcb93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://jobs.utah.gov/usor/",
      "poi_directions_map_url": "https://maps.google.com/?cid=156838034308325528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vocational-rehabilitation-vr",
      "poi_latitude": "41.2207456",
      "poi_longitude": "-111.9543357",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-395-7020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJez8kCoPU4cRmOA3elwzLQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_036125c1-8f32-4abe-bf90-7e551d08ac5f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Minky Couture Executive Offices & Warehouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "475 Depot Dr, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-bc86-72ea-9e3e-90e33577ec87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-bc86-72ea-9e3e-90e33577ec87",
        "storage_key": "property/6767906449167019/019d02d6-bc86-72ea-9e3e-90e33577ec87.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://softminkyblankets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798249156403704470&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "minky-couture-executive-offices--warehouse",
      "poi_latitude": "41.2545591",
      "poi_longitude": "-111.9984389",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 844-222-1967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21DnA0R8O4ARlrJiusyDnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d12d8e91-913c-4ab4-8b1f-1eef5802f9a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Old Post Office Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "298 24th St #120, Ogden, UT 84401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-c1d7-73b7-97cc-873b8fca29e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-c1d7-73b7-97cc-873b8fca29e4",
        "storage_key": "property/6767906449167019/019d02d6-c1d7-73b7-97cc-873b8fca29e4.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14178860600542195897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-post-office-building",
      "poi_latitude": "41.22311029999999",
      "poi_longitude": "-111.9738126",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-392-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxwT3xd0OU4cRuXAZ55duxcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_969fb578-b11b-4597-a758-86073827f1c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "poi_name": "Wasatch Distributing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2057 Rulon White Blvd, Ogden, UT 84404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-c152-77c8-8965-428acc697ed1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-c152-77c8-8965-428acc697ed1",
        "storage_key": "property/6767906449167019/019d02d6-c152-77c8-8965-428acc697ed1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=423041242691148819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wasatch-distributing",
      "poi_latitude": "41.2946898",
      "poi_longitude": "-112.0129199",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-737-1052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-50e9-733f-a20a-ea2120750a8e",
        "storage_key": "property/6767906449167019/019d02d6-50e9-733f-a20a-ea2120750a8e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7y9ziUUNU4cRExzy08Tx3gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_61008f0484754a3055f1930f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_013823a2058619e4d7d8eaab",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2c578f58dcac5cad8f55f323",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d1ec5de8418bc6c354ea32b6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1a43a351024652c27a4b1e98",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_534793dd4be714c7220cf963",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "rating": "5",
      "name": "Alivia Gonzales",
      "text": "I’ve had a great experience living at this community, and the manager Mckenzie has been amazing to work with. She’s always responsive, professional, and genuinely cares about the residents. Any questions or concerns I’ve had were handled quickly and with kindness. Truly appreciate the excellent customer service! The property is well taken care of.",
      "date": "2026-01-12",
      "title": "false"
    },
    {
      "id": "ec_ca013792168346f0f9551b15",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "rating": "5",
      "name": "Sarah Gritters",
      "text": "My husband and I just moved here from about 16 hours away, and we have been very pleased with how Patriot Pointe has handled everything. We toured a lot of townhomes in the area and this one was by far our favorite. The units are in great condition and we just love the safe neighborhood feel of this residence. McKenzie made the rental process feel super easy and any extra fees were highlighted at our first meeting, so they did not come as a surprise. When we first arrived our door code wasn't programed, but after one email that evening it was fixed the next morning and they even came in person to apologize. We've been impressed with how they've handled each situation so far!",
      "date": "2025-09-09",
      "title": "false"
    },
    {
      "id": "ec_124c937b1088c176ad9678af",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "rating": "5",
      "name": "J Gore",
      "text": "A great complex. Nice and quiet area and close to a grocery store. Very clean. Weekly maintenance and the leasing agents are very helpful and professional at all times. The manager is great!",
      "date": "2025-10-29",
      "title": "false"
    },
    {
      "id": "ec_729ff17c1e5dcd484814fe11",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "rating": "5",
      "name": "James Rivera",
      "text": "I’ve lived here for nearly two months and have spent plenty of time inside and out of my townhome.   The neighborhood is quiet and nearly everyone I’ve met has been kind and welcoming.  Working with McKenzie during the application process all the way through to move in and any questions since has been a breeze.  Upon moving in, I had an issue with the refrigerator not operating correctly. The attempt to make repairs were unsuccessful, and a new refrigerator was ordered and installed.",
      "date": "2025-06-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c5b66a4e-ce92-49d3-bdae-51f867a04329",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-f541-759c-8263-4ab7a31dd7c2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, light gray cabinets, and white subway tile backsplash.",
        "public_id": "019d02d6-f541-759c-8263-4ab7a31dd7c2",
        "storage_key": "property/6767906449167019/019d02d6-f541-759c-8263-4ab7a31dd7c2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2.5BA - 1342SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=G9xeVtEQgfq"
    },
    {
      "id": "custom_b93f9822-2248-4fc6-9f4e-409c75dcd643",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-f620-711c-a442-58b40c674022.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d02d6-f620-711c-a442-58b40c674022",
        "storage_key": "property/6767906449167019/019d02d6-f620-711c-a442-58b40c674022.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2.5BA - 1435SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LH2DgfY9PCf"
    },
    {
      "id": "custom_4cbded48-9cf6-4783-9ddc-23f770974d45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167019/019d02d6-f61d-74cb-a22d-46ef73f1056e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen and dining area with island seating and stairs.",
        "public_id": "019d02d6-f61d-74cb-a22d-46ef73f1056e",
        "storage_key": "property/6767906449167019/019d02d6-f61d-74cb-a22d-46ef73f1056e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2.5BA - 1,342SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2j88pFGbHuS"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c77f7-22ea-70dc-bcfe-5da9d2a612bd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-patriot-pointe-townhomes",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "apartments-with-walk-in-closets-north-ogden",
      "search_query": "apartments with walk-in closets North Ogden",
      "category": "Amenity",
      "h1_title": "Apartments With Walk-In Closets in North Ogden",
      "h2_subtitle": "Discover spacious living with walk-in closets right here in North Ogden. Experience the convenience and style at Patriot Pointe Townhomes.",
      "page_copy": "At Patriot Pointe Townhomes, we offer spacious floor plans that include apartment features like walk-in closets, ideal for those who crave organization and convenience in their lifestyle. Nestled in the charming community of North Ogden, our townhomes are designed to provide both comfort and style, making it easy to find exactly what you desire in a new home. \n\nOur townhomes not only boast functional walk-in closets but also come with attached garages and stainless steel appliances. The distinctive wood-style flooring throughout adds a touch of elegance, while the abundant linen closets ensure you never run out of storage space. Located in Weber County, Patriot Pointe is your perfect haven for modern living in North Ogden, where every detail is tailored to meet your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments With Walk-In Closets, North Ogden",
      "seo_description": "Find apartments with walk-in closets at Patriot Pointe Townhomes in North Ogden. Experience spacious living and modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "luxury-apartments-attached-garage-weber-county",
      "search_query": "luxury apartments with attached garage Weber County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments With Attached Garage",
      "h2_subtitle": "Explore exquisite luxury apartments in Weber County, complete with attached garages and sophisticated amenities at Patriot Pointe Townhomes.",
      "page_copy": "Patriot Pointe Townhomes redefines luxury living in Weber County, offering exquisite apartment homes that feature the practicality of attached garages. These residences combine convenience with style, providing you with an exceptional living experience. Nestled in the serene setting of North Ogden, these luxury townhomes deliver both functionality and elegance.\n\nIn addition to attached garages, our townhomes boast standout features such as stainless steel appliances and distinctive wood-style flooring. The spacious floor plans are thoughtfully designed to maximize comfort, while ample linen closets offer generous storage solutions. Discover the refined lifestyle you've been searching for at Patriot Pointe, where every detail has been meticulously curated for luxury living in Weber County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Attached Garage in Weber",
      "seo_description": "Discover luxury living with attached garage apartments at Patriot Pointe, Weber County. Enjoy sophisticated amenities and spacious designs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-north-ogden",
      "search_query": "apartments with stainless steel appliances North Ogden UT",
      "category": "Amenity",
      "h1_title": "Apartments With Stainless Steel Appliances",
      "h2_subtitle": "Find the perfect home in North Ogden, UT, with stainless steel appliances that add a modern touch to your living space at Patriot Pointe Townhomes.",
      "page_copy": "Experience the modern elegance of Patriot Pointe Townhomes in North Ogden, UT, where each apartment is equipped with sleek stainless steel appliances. These high-end appliances not only enhance functionality but also add a contemporary flair to your kitchen, making meal preparation a delightful experience.\n\nPatriot Pointe Townhomes offer more than just beautiful kitchens. Our spacious floor plans come with distinctive wood-style flooring and convenient linen closets, elevating your living experience. With the added benefit of attached garages, our townhomes combine luxury with practicality, making them the ideal choice for those seeking a modern lifestyle in a vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Stainless Steel Appliances, North Ogden",
      "seo_description": "Explore Patriot Pointe Townhomes in North Ogden, UT, featuring apartments with stainless steel appliances and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "spacious-floor-plan-townhomes-near-84414",
      "search_query": "spacious floor plan townhomes near 84414",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plan Townhomes Near 84414",
      "h2_subtitle": "Discover townhomes near the 84414 area offering expansive floor plans. Patriot Pointe Townhomes provides the ultimate in spacious living.",
      "page_copy": "Located conveniently near the 84414 area, Patriot Pointe Townhomes offers residents spacious living with well-designed floor plans that maximize comfort and functionality. Each townhome in our community is thoughtfully crafted to provide ample space for relaxation and everyday living, making it easy to create the home you've always envisioned.\n\nIn addition to expansive interiors, our townhomes feature premium amenities such as attached garages and stainless steel appliances. The distinctive wood-style flooring adds elegance, while the abundant linen closets ensure you have plenty of storage. Experience the perfect blend of style and space at Patriot Pointe Townhomes, your gateway to luxurious living near 84414.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Townhomes Near 84414",
      "seo_description": "Find spacious floor plan townhomes near 84414 at Patriot Pointe, offering luxury features and ample living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "granite-countertops-apartments-north-ogden",
      "search_query": "granite countertops apartments North Ogden",
      "category": "Amenity",
      "h1_title": "Granite Countertops Apartments in North Ogden",
      "h2_subtitle": "Experience elevated living in North Ogden apartments, featuring elegant granite countertops and modern amenities at Patriot Pointe Townhomes.",
      "page_copy": "Patriot Pointe Townhomes in North Ogden set the standard for sophisticated living with their luxurious apartments, highlighted by beautiful granite countertops. These stylish surfaces offer both durability and elegance, making your kitchen a true centerpiece of the home. Enjoy preparing meals in a setting that combines practical design with exceptional craftsmanship.\n\nAt Patriot Pointe, our community goes beyond offering granite countertops. Residents can expect additional top-tier amenities such as attached garages, stainless steel appliances, and spacious floor plans. Distinctive wood-style flooring adds warmth and character, while ample linen closets provide convenient storage. Discover a blend of elegance and modernity in North Ogden at Patriot Pointe Townhomes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apt in North Ogden",
      "seo_description": "Explore North Ogden apartments with granite countertops at Patriot Pointe, where luxury meets modern living and premium features abound.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "two-bedroom-townhomes-north-ogden-ut",
      "search_query": "two bedroom townhomes north ogden ut",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in North Ogden, UT",
      "h2_subtitle": "Explore two bedroom townhomes designed for comfort in North Ogden, UT. Discover the perfect blend of style and space at Patriot Pointe Townhomes.",
      "page_copy": "Patriot Pointe Townhomes offer welcoming two bedroom townhomes, perfect for those seeking a blend of modern style and spacious living in North Ogden, UT. Each unit is thoughtfully designed with comfort in mind, providing ample room for relaxation and daily living, which makes these homes ideal for small families or roommates.\n\nOur townhomes feature a range of premium amenities to enhance your living experience. Enjoy the convenience of an attached garage and the elegance of stainless steel appliances in a kitchen that boasts distinctive wood-style flooring. Ample linen closets offer generous storage solutions, while the expansive floor plans ensure you have all the space you need to live comfortably. Experience sophisticated living at Patriot Pointe Townhomes in North Ogden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes, North Ogden, UT",
      "seo_description": "Discover two bedroom townhomes in North Ogden, UT at Patriot Pointe with spacious layouts and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-weber-county-ut",
      "search_query": "three bedroom apartments weber county ut",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Weber County, UT",
      "h2_subtitle": "Discover spacious three bedroom apartments in Weber County, UT at Patriot Pointe Townhomes, designed for modern living and comfort.",
      "page_copy": "Patriot Pointe Townhomes in Weber County, UT, offers expansive three bedroom apartments perfect for families or those needing extra space. Our thoughtfully designed layouts provide generous living areas and are ideal for both entertaining and intimate family gatherings. Each apartment is infused with modern touches like stainless steel appliances and distinctive wood-style flooring, elevating your home's ambiance.\n\nLocated in the serene setting of Weber County, residents enjoy amenities such as attached garages and ample linen closets, providing convenience and practicality. Our spacious floor plans ensure you have plenty of room to grow and thrive. Discover a vibrant community and inviting atmospheres at Patriot Pointe Townhomes—your gateway to modern living in Weber County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Weber County, UT",
      "seo_description": "Explore three bedroom apartments in Weber County, UT at Patriot Pointe, offering modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "apartments-near-ogden-botanical-gardens-ut",
      "search_query": "apartments near Ogden Botanical Gardens UT",
      "category": "Park",
      "h1_title": "Apartments Near Ogden Botanical Gardens, UT",
      "h2_subtitle": "Find tranquil apartments close to Ogden Botanical Gardens, UT. Enjoy serene surroundings and exceptional amenities at Patriot Pointe Townhomes.",
      "page_copy": "Immerse yourself in nature without sacrificing convenience by choosing Patriot Pointe Townhomes, just a short drive from the Ogden Botanical Gardens, UT. Nestled amidst the picturesque landscapes of North Ogden, our community offers a peaceful retreat while keeping you connected to nature's beauty. Spend your weekends exploring the lush gardens and enjoying the tranquility of the nearby green spaces.\n\nPatriot Pointe Townhomes isn't just about its prime location; we offer a host of features designed for comfort and modern living. Enjoy amenities like stainless steel appliances, attached garages, and expansive floor plans. Our distinctive wood-style flooring and ample linen closets add both style and functionality to your home, making the choice simple when considering your next move.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Ogden Botanical Gardens, UT",
      "seo_description": "Live near Ogden Botanical Gardens, UT at Patriot Pointe Townhomes, offering serene, modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "townhomes-north-ogden-parks-recreation",
      "search_query": "townhomes by North Ogden Parks & Recreation",
      "category": "Park",
      "h1_title": "Townhomes by North Ogden Parks & Recreation",
      "h2_subtitle": "Experience vibrant living in townhomes by North Ogden Parks & Recreation. Enjoy convenient access to outdoor fun and amenities at Patriot Pointe Townhomes.",
      "page_copy": "At Patriot Pointe Townhomes, enjoy the perfect blend of active and comfortable living with convenient proximity to North Ogden Parks & Recreation. Our townhomes provide easy access to a variety of outdoor activities, from hiking trails to family-friendly parks. Whether you're a nature lover or an active enthusiast, our location ensures you can make the most of every season in beautiful North Ogden.\n\nInside your new townhome, you'll find a wealth of amenities designed to cater to modern needs. Benefit from spacious layouts, attached garages, stainless steel appliances, and stylish wood-style flooring. Our large linen closets provide extra storage, ensuring your home remains uncluttered. Patriot Pointe Townhomes are a wonderful choice for those seeking both adventure and modern comforts in their living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes by North Ogden Parks & Rec",
      "seo_description": "Live near North Ogden Parks & Recreation at Patriot Pointe. Enjoy modern townhomes with easy access to outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "patriot-pointe-townhomes-near-barker-park",
      "search_query": "Patriot Pointe Townhomes close to Barker Park",
      "category": "Park",
      "h1_title": "Patriot Pointe Townhomes Close to Barker Park",
      "h2_subtitle": "Explore Patriot Pointe Townhomes, conveniently located close to Barker Park. Enjoy nearby outdoor amenities and modern living spaces.",
      "page_copy": "Nestled in the heart of North Ogden, Patriot Pointe Townhomes offer the perfect blend of convenience and community spirit, being just a stone's throw away from Barker Park. This prime location provides easy access to the park's lush green spaces and vibrant community activities, making it a perfect spot for families and outdoor enthusiasts who seek a balanced lifestyle.\n\nOur townhomes boast state-of-the-art features, including stainless steel appliances and distinctive wood-style flooring, designed to elevate your everyday living experience. Enjoy the convenience of an attached garage and spacious floor plans, ensuring ample space for relaxation and entertainment. Whether you're enjoying a day at the park or relaxing at home, Patriot Pointe Townhomes provide a welcoming sanctuary close to the beauty and activities of Barker Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Patriot Pointe Townhomes Near Barker Park",
      "seo_description": "Discover Patriot Pointe Townhomes close to Barker Park, offering modern features and a prime North Ogden location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167019",
      "source": "generator",
      "page_item_url": "apartments-weber-county-fort-buenaventura-park",
      "search_query": "apartments in Weber County by Fort Buenaventura Park",
      "category": "Park",
      "h1_title": "Apartments in Weber County by Fort Buenaventura",
      "h2_subtitle": "Enjoy convenient living in Weber County with apartments close to Fort Buenaventura Park. Discover vibrant outdoor adventures and modern amenities at Patriot Pointe Townhomes.",
      "page_copy": "Experience the convenience of living near Fort Buenaventura Park with the remarkable Patriot Pointe Townhomes in Weber County. This popular public space offers an array of outdoor activities, such as walking trails, picnic areas, and historical explorations, providing the perfect backdrop for weekend adventures and leisurely strolls.\n\nAt Patriot Pointe Townhomes, you'll find modern comforts and inviting spaces designed to fit your lifestyle. Our apartments feature luxurious stainless steel appliances, distinctive wood-style flooring, and spacious layouts complete with attached garages and ample linen closets. Embrace the ideal balance of nature and modern living in a community that places you close to Fort Buenaventura Park's engaging amenities while enjoying the tranquility of Weber County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in Weber County by Fort Buenaventura Park",
      "seo_description": "Explore Patriot Pointe's modern apartments near Fort Buenaventura Park in Weber County, perfect for outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5899"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11141996408"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MBMC2XH7"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "741PPT"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55404718606"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "11066609-DB00"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjNSU0dNTFl5ZU5rTlNocFpNQlVLNUE9PSIsInZhbHVlIjoiaEVTYkpNNEoxLzlPSWx6d0xYSVRoQT09IiwibWFjIjoiOGM0ODE2YzI3ZWMwZjQzZWM0YTVhZGI1NDkyYThjZDc5ODEzNTlhNjA5OWY1YjMyOTQwZDhmZWJiNjhiNjFmZCJ9"
    }
  ],
  "custom_qb_id": "5899",
  "custom_repli_id": "11141996408",
  "custom_google_gtm_id": "GTM-MBMC2XH7",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "741PPT",
  "custom_hubspot_company_id": "55404718606",
  "custom_broker_license_number": "11066609-DB00",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjNSU0dNTFl5ZU5rTlNocFpNQlVLNUE9PSIsInZhbHVlIjoiaEVTYkpNNEoxLzlPSWx6d0xYSVRoQT09IiwibWFjIjoiOGM0ODE2YzI3ZWMwZjQzZWM0YTVhZGI1NDkyYThjZDc5ODEzNTlhNjA5OWY1YjMyOTQwZDhmZWJiNjhiNjFmZCJ9",
  "custom_audioeye_site_id": "32aae927-681f-4d64-ae98-25e0f0bd3776",
  "custom_audioeye_site_hash": "0bed45122519702ffac6f68c452a9aba"
};

export const generatedAt = '2026-10-05T17:25:08.608Z';
